module.exports = __webpack_public_path__ + "img/icon-close-x.b090648e189ac725070fbf3f3c7c6c1d.png";